import PlaceList from './PlaceList'
import PlaceCreate from './PlaceCreate'
import PlaceEdit from './PlaceEdit'

export default {
  list: PlaceList,
  create: PlaceCreate,
  edit: PlaceEdit,
}
